<div *ngIf="this.navbarService.identity?.status === 'BLOCKED_BY_ADMIN'" class="row mt-3">
  <div class="col-sm-12">
    <div class="row ms-3 me-1">
      <div class="alert alert-danger vid-list-item-description col-sm-12" role="alert">
        <span>{{ 'AUTHENTICATORS.BLOCKED_BY_ADMIN_BANNER' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="this.navbarService.identity?.status === 'BLOCKED'" class="row mt-3">
  <div class="col-sm-12">
    <div class="row ms-3 me-1">
      <div class="alert alert-warning vid-list-item-description col-sm-12" role="alert">
        <span>{{ 'AUTHENTICATORS.UNBLOCK_IDENTITY_BANNER' | translate }}</span>
        <span>
                    <button id="unblockIdentity" class="vid-btn vid-btn-yellow vid-btn-sm ms-2 float-end" type="button"
                            (click)="onUnblockIdentity()">
                        {{ 'AUTHENTICATORS.UNBLOCK_IDENTITY_BTN' | translate }}
                    </button>
                </span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isEmptyAuthenticatorsList" class="row mt-3">
  <div class="col-sm-12">
    <div class="row ms-3 me-1">
      <div class="alert alert-info vid-list-item-description col-sm-12" role="alert">
        <span>{{ 'AUTHENTICATORS.EMPTY_AUTHENTICATORS_BANNER' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isEmptyAuthenticatorsList" class="row mt-3">
  <div class="col-sm-10">
    <div class="vid-main-content">
      <div class="row vid-column-equal">
        <div class="col-sm-6 mb-4" *ngFor="let deviceAuthenticators of deviceAuthenticatorsList"
             [ngClass]="{'vid-hidden': deviceAuthenticators.type == 'OTHERS' && deviceAuthenticators.authenticators.length == 0}">
          <div class="vid-card p-2">
            @if (deviceAuthenticators.type === 'OTHERS') {
              <app-other-authenticators [deviceAuthenticator]="deviceAuthenticators"
                                        [hideRemoveAuthenticatorsButton]="hideRemoveAuthenticatorsButton"
                                        [adPasswordSelfRenewal]="adPasswordSelfRenewal"
                                        [adPasswordSelfReset]="adPasswordSelfReset"
                                        [iconMapping]="iconMapping"
                                        (onRemoveAuthenticator)="removeAuth($event)"
                                        (onLdapReset)="resetLdapPassword($event?.ldapMethod, $event?.row)"
                                        (onResetPin)="onResetPin()">
              </app-other-authenticators>
            } @else {
              <app-device-authenticators [deviceAuthenticator]="deviceAuthenticators"
                                         [iconMapping]="iconMapping"
                                         [isSynchronizing]="isSynchronizing"
                                         [hideRemoveAuthenticatorsButton]="hideRemoveAuthenticatorsButton"
                                         (onBlockDeviceEvent)="onBlockDevice($event)"
                                         (onRemoveDeviceEvent)="onRemoveDevice($event)"
                                         (onUnblockDeviceEvent)="onUnblockDevice($event)"
                                         (onSyncEntraPasskeys)="onSyncEntraPasskeys($event)"
                                         (onRemoveAuthenticator)="removeAuth($event)"
                                         (onResetPin)="onResetPin()">
              </app-device-authenticators>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-2">
    <div *ngIf="staticResources.isI18nConfigFetched" class="vid-right-side-menu vid-side-menu-no-top">
      <div class="mb-2 p-2">
        <span class="section-title">{{ 'AUTHENTICATORS.HELP' | translate }}</span>
        <div class="settings-activity">

          <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
            {{ 'AUTHENTICATORS.HELP_ENROLLMENT' | translate }}
          </div>

          <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
            {{ 'AUTHENTICATORS.HELP_BLOCK_DEVICE' | translate }}
            <hr>
            {{ 'AUTHENTICATORS.HELP_REMOVE_DEVICE' | translate }}
          </div>

          <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
            {{ 'AUTHENTICATORS.HELP_REMOVE_AUTHENTICATOR' | translate }}
            <hr>
            {{ 'AUTHENTICATORS.HELP_RESET_PIN' | translate }}
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
